'use strict';

import {setupVariationListeners, afterAttributeSelect} from './variationsUtils';
import {setupAddToCart} from './addToCart';
import {setupConfirmEngravAddToCart, setupConfirmEmbossAddToCart, setupConfirmBraceletAdjustmentAddToCart, updateEngvPreview} from './productPersonalisation';
import {setupZoomTriggers} from './productZoom';
import {initShareLink} from './productUtils';
import {setupProductDescription} from './productDescription';
import {widget3DConfiguration} from './widget3D';
import {refillsSetup} from './caseRefills';
import * as applepayapi from '../applepayapi';
import {vtoSetup} from './virtualTryOnPDP';

export default {
    setupAddToCart: setupAddToCart,
    setupConfirmEngravAddToCart: setupConfirmEngravAddToCart,
    setupConfirmEmbossAddToCart: setupConfirmEmbossAddToCart,
    setupConfirmBraceletAdjustmentAddToCart: setupConfirmBraceletAdjustmentAddToCart,
    updateEngvPreview: updateEngvPreview,
    setupVariationListeners: setupVariationListeners,
    setupZoom: setupZoomTriggers,
    setupProductDescription: setupProductDescription,
    widget3DConfiguration: widget3DConfiguration,
    refillsSetup: refillsSetup,
    initShareLink: initShareLink,
    afterAttributeSelect: afterAttributeSelect,
    applepayapi: applepayapi.init,
    vtoSetup: vtoSetup
};
